
jQuery.getJSON('/cart.js', function(cart) {
  
  console.log(cart);
  
  const items = cart.items.map(item => {
    
    var container = "updates["+item.variant_id+"]="+item.quantity;
    console.log(container);
    return container;
})
 console.log(customerId);
  var custId = customerId;
  var cartoken = items.toString();
  
  console.log(cartoken);
  
  if(custId != ""){ 
    
    getWish(custId,cartoken);    
//   setInterval(function(){ updateCart(); }, 10000);  
  }else{
  
  }
      
});



function addWish(cst_id,cart_token) {
  
  console.log('testing');
  
  var cstid = cst_id;
  var cartoken = cart_token;
  
  var addwish = "https://ritzfair2.com/tokenadd.php";
  var params = 'cstid='+cstid+'&cartoken='+cartoken;
  
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
   // console.log("Added or Updated");
    }
  };
  xhttp.open("POST", addwish, true);
  //Send the proper header information along with the request
	xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhttp.send(params);  
  
  setTimeout(function(){
    var loadval = localStorage.getItem("loadval");
        console.log('checking new'+loadval);
        if( loadval == 1){
          
          localStorage.setItem("loadval", 2);
          
          location.reload();

        }
    
  }, 1000);
  
}

function getWish(cst_id,cart_token) {
  
  var cstid = cst_id;
  var cartoken = cart_token;
  
  var getwish = "https://ritzfair2.com/tokenget.php?cstid="+cstid;
 // var params = 'cstid='+cstid+'&cartoken='+cartoken;
  
  var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      
      var obj = $.parseJSON(this.responseText);
     
      if(obj.status == 1){        
      var itemss = obj.data[0].cartoken;  
        console.log(itemss);
      itemss = itemss.split(',').join('&');

//       $.post('/cart/clear.js');
        console.log('test----69');
      $.post('/cart/update.js', itemss); 
        
      }else{
        console.log('test----71');
//       addWish(cstid,cartoken);  
      }
      
    }
  };
  xhttp.open("GET", getwish, true);
  //Send the proper header information along with the request
	xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhttp.send();
}

// function updateCart() {
//   $.getJSON('/cart.js', function(cart) {
  
//   const items = cart.items.map(item => {
    
//     var container = "updates["+item.variant_id+"]="+item.quantity;
//     return container;
// })
 
//   var custId = customerId;
//   var cartoken = items.toString();

// console.log(items+'------95------');
      
//   if(custId != ""){   
//     console.log('------98------');
//   addWish(custId,cartoken);
//   }
      
// });
// }

// function getCookieValue(name) {
//   let result = document.cookie.match("(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)")
//   return result ? result.pop() : ""
// }
